import { getResearchArticleIndexPath } from 'site-modules/editorial/utils/content-path';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getPageOptions } from 'site-modules/editorial/pages/research-article/research-article-definition';
import { ResearchType } from './research-type';

const pages = new Map();
export default ({ articleCategory, articleId, splat, chunkName }) => {
  const key = getResearchArticleIndexPath(articleCategory, articleId, splat);
  let page = pages.get(key);
  if (!page) {
    page = pageDefinition(
      getPageOptions({
        articleCategory,
        articleId,
        splat,
        chunkName,
        preloadHeroImage: true,
        pageTemplate: ResearchType,
      })
    );
    pages.set(key, page);
  }
  return page;
};
